import request from '@/shared/request';
import qs from 'qs';
import env from '../env';
import app from '@/app/app';

export default {
  send(event: string, ext: string) {
    const query = qs.parse(window.location.search.slice(1));

    if (query.source) {
      app
        .getStore()
        ?.dispatch.user.ensureUserInfo({})
        .then(([err, userInfo]) => {
          if (err) return;

          request
            .post('/api/speed/appsviewtatistics', {
              data: {
                anonymousid: '',
                source: query.channel || '',
                event,
                ext,
                medUserId: userInfo.base.userId,
                medUserPhone: userInfo.base.phone,
                platform:
                  {
                    jxyhyb: 1,
                    jxyjsb: 2,
                    jxyzjb: 3,
                    jxyallinone: 30,
                  }[query.source as string] || '',
              },
              baseURL:
                env.appEnv === 'prod'
                  ? 'https://medgptv2-prod.medlinker.com'
                  : 'https://medgptv2-qa.medlinker.com',
            })
            .then(() => {
              //
            })
            .catch(err => console.log('report error', err));
        })
        .catch(err => console.log('report error 2', err));
    }
  },
  sendNewReport(event: string) {
    const query = qs.parse(window.location.search.slice(1));

    if (query.source) {
      app
        .getStore()
        ?.dispatch.user.ensureUserInfo({})
        .then(([err, userInfo]) => {
          if (err) return;

          request
            .post('/gpt-c-interface/v1/event/eventReport', {
              data: {
                event,
                platform:
                  {
                    jxyallinone: 30,
                    jxyjsb: 2,
                    jxyhyb: 1,
                  }[query.source as string] || '',
                anonymousid: '',
              },
              // headers: {
              //   sess: query.sess,
              //   msess: query.msess,
              //   token: query.token,
              // },
              baseURL:
                env.appEnv === 'prod'
                  ? 'https://api.medlinker.com'
                  : 'https://api-qa.medlinker.com',
            })
            .then(() => {
              //
            });
        });
    }
  },
};
